<template>
    <div
        class="RiskProfileAssignmentOptions"
        :class="{ 'RiskProfileAssignmentOptions--disabled': isDisabled }"
    >
        <div class="RiskProfileAssignmentOptions__title">
            <span>Applies to</span>
            <span class="ml-1 text-red-500">*</span>
        </div>
        <NewDropdown
            :selected="selectedOption"
            :options="dropdownOptions"
            :disabled="isDisabled"
            hide-selected-chip
            @input="onSelect"
        />
    </div>
</template>
<style lang="scss">
.RiskProfileAssignmentOptions {
    &__title {
        margin-bottom: 4px;
    }

    &--disabled &__title {
        opacity: 0.5;
        cursor: not-allowed;
    }
}
</style>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { NewDropdown } from '@evidentid/dashboard-commons/components/Dropdown';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';
    import { AssignmentRuleType } from '@evidentid/tprm-portal-lib/models/decisioning/AssignmentRule.model';

    export default defineComponent({
        name: 'RiskProfileAssignmentOptions',
        components: {
            NewDropdown,
        },
        props: {
            assignmentOption: {
                type: String as PropType<AssignmentRuleType | null>,
                default: null,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },
        emits: [ 'setAssignmentRuleOption' ],
        computed: {
            dropdownOptions(): DropdownOption<AssignmentRuleType>[] {
                return [
                    {
                        label: 'All entities',
                        value: AssignmentRuleType.all,
                    },
                    {
                        label: 'One entity',
                        value: AssignmentRuleType.single,
                    },
                    {
                        label: 'Rule-based entities',
                        value: AssignmentRuleType.selected,
                    },
                ];
            },
            selectedOption(): DropdownOption<AssignmentRuleType> | null {
                return this.dropdownOptions.find((opt) => opt.value === this.assignmentOption) || null;
            },
        },
        methods: {
            onSelect(option: DropdownOption<AssignmentRuleType>): void {
                this.$emit('setAssignmentRuleOption', option.value);
            },
        },
    });
</script>
